import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import { SiteDetailService } from '../site-detail';
import { SiteEditService } from './site-edit.service';
import { Site } from './../../../../model';

@Component({
  selector: 'app-site-edit',
  templateUrl: './site-edit.component.html'
})
export class SiteEditComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;

  siteId = ''; // site id
  site: any;
  // model = new Site('', '', '', '', '', '', '', '', '', '', '', '', '');
  redirect = true;

  editSiteForm: FormGroup;

  customerId: String = '';
  customerShortName: String = '';
  customerName: String = '';
  locationShort: String = '';
  location: String = '';
  endUser: String = '';
  contactNameOne: String = '';
  contactNumberOne: String = '';
  contactEmailOne: String = '';
  contactNameTwo: String = '';
  contactNumberTwo: String = '';
  contactEmailTwo: String = '';

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private siteDetailService: SiteDetailService,
    private siteEditService: SiteEditService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.siteId = params['id'];
    });
  }

  ngOnInit() {
    this.createEditSiteForm();
    this.getDetail();
  }

  createEditSiteForm() {
    this.editSiteForm = this.formBuilder.group({
      customerId: new FormControl('', [
      ]),
      customerShortName: new FormControl('', [
      ]),
      customerName: new FormControl('', [
      ]),
      locationShort: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      location: new FormControl('', [
        Validators.required,
        Validators.maxLength(300)
      ]),
      endUser: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactNameOne: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactNumberOne: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactEmailOne: new FormControl('', [
        Validators.pattern('^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+(, *)?)+$'),
        Validators.maxLength(100)
      ]),
      contactNameTwo: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactNumberTwo: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactEmailTwo: new FormControl('', [
        Validators.pattern('^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+(, *)?)+$'),
        Validators.maxLength(100)
      ]),
      remarks: new FormControl('', [
        Validators.maxLength(1000)
      ])
    });
  }

  editSite(editSiteForm) {
    this.siteEditService
      .edit(this.siteId, editSiteForm.controls)
      .subscribe(
        data => {
          if (data) {
            // this.model = data;
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  getDetail() {
    this.siteDetailService
      .getDetail(this.siteId)
      .subscribe(
        data => {
          if (data) {
            // this.model = data;
            this.site = data;
            this.editSiteForm.setValue({
              customerId: this.site.customerId,
              customerShortName: this.site.customerShortName,
              customerName: this.site.customerName,
              locationShort: this.site.locationShort,
              location: this.site.location,
              endUser: this.site.endUser,
              contactNameOne: this.site.contactNameOne,
              contactNumberOne: this.site.contactNumberOne,
              contactEmailOne: this.site.contactEmailOne,
              contactNameTwo: this.site.contactNameTwo,
              contactNumberTwo: this.site.contactNumberTwo,
              contactEmailTwo: this.site.contactEmailTwo,
              remarks: this.site.remarks
            });
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  closeSuccessModel() {
    this.router.navigate(['/home/site/detail/' + this.siteId]);
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/site']);
    } else {
      this.dangerModal.hide();
    }
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-edit/site-edit.component.ts